var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFamilyMonth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M681.212 205.546L797.463 205.546C807.049 205.546 814.819 211.726 814.819 219.349L814.819 420.562C814.819 428.184 807.049 434.364 797.463 434.364L681.212 434.364C671.626 434.364 663.855 428.184 663.855 420.562L663.855 219.349C663.855 211.726 671.626 205.546 681.212 205.546Z",
    fill: "#f7658e",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M897.791 500.501L126.209 500.501C99.1138 500.501 93.6974 486.686 114.111 469.644L446.772 191.931C482.797 161.857 541.203 161.857 577.228 191.931L909.889 469.644C930.303 486.686 924.886 500.501 897.791 500.501Z",
    fill: "#f7658e",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.594 470.976L463.154 265.673C490.5 244.61 534.725 244.742 561.933 265.967L827.347 473.024C835.062 479.043 841.316 491.616 841.316 501.108L841.316 834.718C841.316 868.907 812.181 896.623 776.242 896.623L250.865 896.623C214.739 896.623 185.258 868.763 185.019 834.397L182.684 498.953C182.618 489.47 188.846 476.944 196.594 470.976Z",
    fill: "#ffeaeb",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.063 896.623L238.628 895.73C221.667 895.677 208.182 881.887 208.508 864.929L210.539 759.322C210.539 728.311 239.178 709.333 260.882 707.299L319.617 703.467L412.24 703.281L467.53 707.299C494.731 709.333 517.873 728.311 517.873 759.322L525.063 896.623Z",
    fill: "#289bc7",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.857 547.864L365.968 547.864C406.558 547.864 439.462 585.195 439.462 631.245L439.462 631.245C439.462 677.296 406.558 714.627 365.968 714.627L362.857 714.627C322.268 714.627 289.363 677.296 289.363 631.245L289.363 631.245C289.363 585.195 322.268 547.864 362.857 547.864Z",
    fill: "#f9cfa3",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.648 651.617L365.464 651.617C389.169 651.617 408.386 673.29 408.386 700.024L408.386 700.024C408.386 726.759 389.169 748.432 365.464 748.432L363.648 748.432C339.942 748.432 320.726 726.759 320.726 700.024L320.726 700.024C320.726 673.29 339.942 651.617 363.648 651.617Z",
    fill: "#f9cfa3",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.687 532.554L366.828 532.554C410.697 532.554 443.362 569.828 443.362 622.767L437.52 651.899C429.835 680.552 436.7 638.967 416.434 601.215C409.444 588.194 346.995 574.738 308.911 597.794C303.126 601.297 292.28 660.548 292.28 660.548C292.28 660.548 284.243 635.501 289.709 584.049C290.893 572.909 283.896 585.721 279.006 571.649C279.006 571.649 283.327 570.605 288.167 564.195C290.228 561.466 279.191 555.789 281.226 553.338C297.521 533.716 335.432 532.554 361.687 532.554Z",
    fill: "#37393e",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.864 654.155L610.533 704.833C605.747 723.028 613.127 737.859 627.018 737.959L750.901 738.85C764.792 738.95 772.666 724.047 768.487 705.562L757.646 657.6",
    fill: "#332e29",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.605 896.623C564.299 896.623 559.448 891.409 559.77 884.977L565.015 780.162C565.015 753.858 588.228 737.761 605.82 736.036L653.428 732.785L728.503 732.628L773.318 736.036C795.365 737.761 814.123 753.858 814.123 780.162L818.073 859.085C819.11 879.817 803.124 896.623 782.366 896.623L570.605 896.623Z",
    fill: "#e77865",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.908 589.303L692.5 589.303C726.329 589.303 753.753 622.071 753.753 662.493L753.753 662.493C753.753 702.915 726.329 735.683 692.5 735.683L689.908 735.683C656.079 735.683 628.656 702.915 628.656 662.493L628.656 662.493C628.656 622.071 656.079 589.303 689.908 589.303Z",
    fill: "#f0b98b",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.566 685.084L692.08 685.084C711.837 685.084 727.853 705.091 727.853 729.772L727.853 729.772C727.853 754.452 711.837 774.459 692.08 774.459L690.566 774.459C670.81 774.459 654.794 754.452 654.794 729.772L654.794 729.772C654.794 705.091 670.81 685.084 690.566 685.084Z",
    fill: "#f0b98b",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.959 581.048L693.449 581.048C731.755 581.048 762.809 615.567 762.809 658.147L762.809 658.147C762.809 679.257 689.265 608.05 690.969 607.937C693.816 607.747 619.599 679.619 619.599 658.147L619.599 658.147C619.599 615.567 650.653 581.048 688.959 581.048Z",
    fill: "#332e29",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.677 896.062L441.876 896.062C436.519 896.062 432.399 892.06 432.672 887.124L437.128 806.685C437.128 786.498 456.845 774.145 471.788 772.821L512.228 770.326L575.998 770.205L614.065 772.821C632.793 774.145 648.726 786.498 648.726 806.685L653.677 896.062Z",
    fill: "#fcef6d",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.066 656.924L543.67 656.924C577.65 656.924 605.196 684.163 605.196 717.763L605.196 717.763C605.196 751.364 577.65 778.602 543.67 778.602L541.066 778.602C507.086 778.602 479.54 751.364 479.54 717.763L479.54 717.763C479.54 684.163 507.086 656.924 541.066 656.924Z",
    fill: "#fab88a",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.719 717.974L544.067 717.974C561.649 717.974 575.903 733.787 575.903 753.294L575.903 753.294C575.903 772.801 561.649 788.614 544.067 788.614L542.719 788.614C525.137 788.614 510.883 772.801 510.883 753.294L510.883 753.294C510.883 733.787 525.137 717.974 542.719 717.974Z",
    fill: "#fab88a",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.439 649.579C572.716 648.022 605.836 672.183 611.693 707.125C611.714 711.523 609.307 711.628 603.356 711.086C592.602 710.107 581.189 709.013 566.125 707.479C562.485 707.109 556.226 679.292 556.226 679.292C556.226 679.292 557.749 706.947 552.998 707.096C549.374 707.209 526.416 707.004 522.655 707.287C519.83 707.501 522.655 678.333 522.655 678.333C522.655 678.333 514.18 707.456 511.679 707.671C500.849 708.602 473.765 711.458 474.665 706.329C480.691 672.005 508.194 651.233 541.439 649.579Z",
    fill: "#33353a",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M571.601 740.018C571.601 741.921 570.755 749.112 566.306 755.529L546.567 755.529L520.372 755.529C515.923 749.112 515.045 741.921 515.202 740.018L571.601 740.018Z",
    fill: "#6f493d",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.306 755.529C562.327 761.37 555.339 766.57 543.402 766.57C531.464 766.57 524.445 761.37 520.372 755.529C520.372 755.529 526.56 751.081 543.402 751.081C560.243 751.081 566.306 755.529 566.306 755.529Z",
    fill: "#c83030",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M719.532 690.445C719.532 692.214 718.686 698.899 714.236 704.863L694.497 704.863L668.302 704.863C663.853 698.899 662.975 692.214 663.132 690.445L719.532 690.445Z",
    fill: "#6f493d",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.236 704.863C710.257 710.293 703.27 715.127 691.332 715.127C679.394 715.127 672.375 710.293 668.302 704.863C668.302 704.863 674.49 700.729 691.332 700.729C708.173 700.729 714.236 704.863 714.236 704.863Z",
    fill: "#c83030",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397.133 669.981C397.133 672.134 396.152 680.271 390.991 687.531L368.095 687.531L337.709 687.531C332.548 680.271 331.531 672.134 331.712 669.981L397.133 669.981Z",
    fill: "#6f493d",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.991 687.531C386.375 694.141 378.27 700.024 364.423 700.024C350.575 700.024 342.434 694.141 337.709 687.531C337.709 687.531 344.887 682.499 364.423 682.499C383.958 682.499 390.991 687.531 390.991 687.531Z",
    fill: "#c83030",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M377.409 631.245C377.409 631.245 383.229 626.747 390.405 626.747C397.582 626.747 403.401 631.245 403.401 631.245M320.726 631.245C320.726 631.245 326.545 626.747 333.722 626.747C340.898 626.747 346.718 631.245 346.718 631.245",
    fill: "none",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "#37393e",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.739 722.434C558.739 722.434 564.558 717.935 571.735 717.935C578.911 717.935 584.731 722.434 584.731 722.434M502.055 722.434C502.055 722.434 507.875 717.935 515.051 717.935C522.228 717.935 528.048 722.434 528.048 722.434",
    fill: "none",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "#37393e",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.55 666.991C706.55 666.991 712.369 662.493 719.546 662.493C726.722 662.493 732.542 666.991 732.542 666.991M649.866 666.991C649.866 666.991 655.686 662.493 662.862 662.493C670.039 662.493 675.859 666.991 675.859 666.991",
    fill: "none",
    fillRule: "evenodd",
    opacity: 1,
    stroke: "#37393e",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamilyMonth);
export default __webpack_public_path__ + "static/media/FamilyMonth.360b4d39b9588474725b8032408b9718.svg";
export { ForwardRef as ReactComponent };